import { Khi2Test } from './analyse.model';

export class Contingency {
  name: string;
  test: string;
  subTests: Array<{ name: string; code: string }>;
  categories: Array<ContingencyCategory>;
  total: ContingencyCategory;

  constructor(name: string, test: string) {
    this.name = name;
    this.test = test;
    this.subTests = [];
    this.categories = [];
    this.total = new ContingencyCategory('total');
  }
}

export class ContingencyCategory {
  name: string;
  field: string;
  control: ContingencyBlock;
  test: ContingencyBlock;
  subTests: Array<ContingencyBlock>;
  total: ContingencyBlock;
  khi2Tests?: Array<Khi2Test>;
  pValue: number;
  BF?: boolean;
  FDR?: boolean;
  qvalue?: boolean;

  constructor(name: string, field: string = 'all') {
    this.name = name;
    this.field = field;
    this.control = new ContingencyBlock();
    this.test = new ContingencyBlock();
    this.subTests = [];
    this.total = new ContingencyBlock();
    this.khi2Tests = [];
  }
}

export class ContingencyBlock {
  count: number;
  inCategory: number;
  inTest: number;
  total: number;

  constructor() {
    this.count = 0;
    this.inCategory = 0;
    this.inTest = 0;
    this.total = 0;
  }
}
